/* eslint-disable max-len */
import { VoidCallback } from '@deqo/foundation';
import React from 'react';
import { useEffectOnce } from 'react-use';
import { LFC } from '../../../Legacy';
import { defineCommand } from '../../../concepts/commands/CommandDefinition';
import { CommandRegistry } from '../../../concepts/commands/CommandRegistry';
import { Prompt } from '../../../ui';
import { Position } from '../../../ui/Position';
import { useResolve } from '../../Container';
import { Popup, PopupProps } from '../../popups/Popup';
import { PointerHandler } from '../PointerHandler';
import { OverlayLayer } from '../overlay/OverlayLayer';
import { ToolLayer } from '../tooling/ToolLayer';
import { CanvasView } from '../ui/CanvasView';
import { HtmlRenderer } from '../visualization/HtmlRenderer';
import { ReplayControlView } from './ReplayControlView';
import { ReplayCopyView } from './ReplayCopyView';
import { ReplayLoader } from './ReplayLoader';
import { ReplayScope } from './ReplayScope';

const DefineExitCommand = ({ dismiss }: { dismiss: VoidCallback }) => {
    const commands = useResolve(CommandRegistry);
    useEffectOnce(() => {
        commands.add(
            defineCommand('exit', 'Exit', () => dismiss())
        );
    });
    return null;
};

export const replayPopup = (boardId: string, elmtId?: string) => ({
    ui: ReplayPopup,
    fullscreen: true,
    args: { boardId, elmtId },
});

export const ReplayPopup: LFC<PopupProps> = ({ dismiss, args }) => {
    const { boardId, elmtId } = args;

    return <Prompt name="popup" ignoreEnter ignoreMouse onAction={dismiss}>
        <Popup p="0">
            <ReplayScope boardId={boardId} elmtId={elmtId} loader={ReplayLoader}>
                <DefineExitCommand dismiss={dismiss} />
                <CanvasView>
                    <HtmlRenderer />
                    <PointerHandler />
                    <ToolLayer />
                    <OverlayLayer />
                    <ReplayControlView />
                    <ReplayCopyView />
                </CanvasView>
            </ReplayScope>
            <Position at="topRight" inset=".5">
                <Popup.Close onAction={dismiss} />
            </Position>
        </Popup>
    </Prompt>;
};
